module.exports = __webpack_public_path__ + "img/ck.bd3a061.svg";